export default {
  '001': {
    url: 'https://www.youtube.com/embed/dr5yBBAR9Tg?autoplay=1',
    date: '2020.01.24',
    title: 'ティザーPV',
    image: '/assets/images/pv-poster1.png'
  },
  '002': {
    url: 'https://www.youtube.com/embed/WUMAeUwxsCk?autoplay=1',
    date: '2020.05.08',
    title: 'MAIN PV',
    image: '/assets/images/pv-poster2.jpg'
  },
  '003': {
    url: 'https://www.youtube.com/embed/x1mrQERwL4Y?autoplay=1',
    date: '2020.05.22',
    title: 'プロジェクトPV',
    image: '/assets/images/pv-poster3.png'
  },
  '005': {
    url: 'https://www.youtube.com/embed/NB0-u9eRhPk?autoplay=1',
    date: '2020.06.26',
    title: 'MAIN PV #2',
    image: '/assets/images/pv-poster5.jpg'
  },
  '006': {
    url: 'https://www.youtube.com/embed/Hmr5XmAzcRU?autoplay=1',
    date: '2020.07.07',
    title: '主題歌スペシャルPV',
    image: '/assets/images/pv-poster4.jpg'
  },
  '007': {
    url: 'https://www.youtube.com/embed/XR4F-U8xVMQ?autoplay=1',
    date: '2020.08.11',
    title: 'MAIN PV #3',
    image: '/assets/images/pv-poster7.jpg'
  },
  '008': {
    url: 'https://www.youtube.com/embed/ug0Mc94Ye1I?autoplay=1',
    date: '2020.08.14',
    title: 'ノンクレジットED',
    image: '/assets/images/pv-poster8.jpg'
  },
  '009': {
    url: 'https://www.youtube.com/embed/Yjv_yFgHYc0?autoplay=1',
    date: '2020.08.14',
    title: 'ノンクレジットOP',
    image: '/assets/images/pv-poster9.jpg'
  },
  '010': {
    url: 'https://www.youtube.com/embed/-B_bngu3lBk?autoplay=1',
    date: '2020.09.14',
    title: 'MAIN PV #4',
    image: '/assets/images/pv-poster10.jpg'
  },
  '011': {
    url: 'https://www.youtube.com/embed/VVAPTAXbn5U?autoplay=1',
    date: '2020.10.10',
    title: 'スペシャルMV',
    image: '/assets/images/pv-poster11.jpg'
  },
  '012': {
    url: 'https://www.youtube.com/embed/y2uUsXGIgOY?autoplay=1',
    date: '2020.10.19',
    title: 'MAIN PV #5',
    image: '/assets/images/pv-poster12a.jpg'
  },
  '013': {
    url: 'https://www.youtube.com/embed/5dfwMkoEBHo?autoplay=1',
    date: '2020.12.24',
    title: 'フジテレビ アニメラインナップ発表会',
    image: '/assets/images/pv-poster13.jpg'
  },
  '014': {
    url: 'https://www.youtube.com/embed/vauktEVjIvg?autoplay=1',
    date: '2023.11.17',
    title: 'GREAT PRETENDER razbliuto ティザー',
    image: '/assets/images/pv-poster14.jpg'
  },
  '015': {
    url: 'https://www.youtube.com/embed/eH29XcLAJF8?autoplay=1',
    date: '2023.12.19',
    title: 'razbliuto PV第一弾',
    image: '/assets/images/pv-poster15.jpg'
  },
  '016': {
    url: 'https://www.youtube.com/embed/qwRdgevao6I?autoplay=1',
    date: '2023.12.19',
    title: 'razbliuto PV第二弾',
    image: '/assets/images/pv-poster16.jpg'
  }
}



// WEBPACK FOOTER //
// ./src/data/video.js